/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Error_Pleasetryagainlater3Inputs */

const en_common_error_pleasetryagainlater3 = /** @type {(inputs: Common_Error_Pleasetryagainlater3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please try again later.`)
};

/**
* | output |
* | --- |
* | "Please try again later." |
*
* @param {Common_Error_Pleasetryagainlater3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_error_pleasetryagainlater3 = /** @type {((inputs?: Common_Error_Pleasetryagainlater3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Error_Pleasetryagainlater3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_error_pleasetryagainlater3(inputs)
});
export { common_error_pleasetryagainlater3 as "common_error_pleaseTryAgainLater" }